import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { AgentResponseDTO, LocationsDTO } from 'models'
import { FormCreditorKeys } from './types'

interface Schema {
    id: FormCreditorKeys
}

export const FormCreditorValue = (
    location: LocationsDTO[],
    agentes: AgentResponseDTO[]
): {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}[] => [
    {
        select: {
            id: 'cnpj',
            label: 'Agentes financeiros',
            isLoading: true,
            options: agentes?.map(({ cnpj, razaoSocial }) => ({
                text: razaoSocial,
                value: cnpj
            }))
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'email',
            label: 'Email'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'endereco.cep',
            label: 'CEP',
            maskReplace: 'cep',
            inputMode: 'numeric'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    },
    {
        input: {
            id: 'endereco.uf',
            label: 'UF'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.municipio',
            label: 'Município'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
        }
    },
    {
        input: {
            id: 'endereco.logradouro',
            label: 'Logradouro'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'endereco.bairro',
            label: 'Bairro'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.numero',
            label: 'Número'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'endereco.complemento',
            label: 'Complemento ou referência',
            placeholder: '-'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
        }
    },
    {
        input: {
            id: 'telefone',
            label: 'Telefone',
            maskReplace: 'contato',
            placeholder: '-'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    }
]
